import { Grid } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailRadio from "src/components/shared-components/ByzMcParameterDetailRadio";

interface PippScaleProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
}

const PippScale: React.FC<PippScaleProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
}) => {
  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.pipp-scale.title")} />

      <ByzCard sx={{ padding: 0, ml: 1, mb: 1 }}>
        {/* 1. Grup - Gebelik Yaşı - Davranışsal Durum - Alınını Kırıştırma */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-gestational-age")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_GESTATIONAL_AGE.mcpId}
              value={selectedMCPs.PIPP_GESTATIONAL_AGE}
              handleChange={(val) =>
                val && handleMCPChange("PIPP_GESTATIONAL_AGE", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_GESTATIONAL_AGE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-behavioral-state")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_BEHAVIORAL_STATE.mcpId}
              value={selectedMCPs.PIPP_BEHAVIORAL_STATE}
              handleChange={(val) => val && handleMCPChange("PIPP_BEHAVIORAL_STATE", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_BEHAVIORAL_STATE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-brow-bulge")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_BROW_BULGE.mcpId}
              value={selectedMCPs.PIPP_BROW_BULGE}
              handleChange={(val) => val && handleMCPChange("PIPP_BROW_BULGE", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_BROW_BULGE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
        {/* 2. Grup -  Maks kalp atışı - Min Oksijen saturation - Gözlerini Sıkma*/}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-max-heart-rate")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_MAX_HEART_RATE.mcpId}
              value={selectedMCPs.PIPP_MAX_HEART_RATE}
              handleChange={(val) =>
                val && handleMCPChange("PIPP_MAX_HEART_RATE", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_MAX_HEART_RATE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-min-oxygen-saturation")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_MIN_OXYGEN_SATURATION.mcpId}
              value={selectedMCPs.PIPP_MIN_OXYGEN_SATURATION}
              handleChange={(val) => val && handleMCPChange("PIPP_MIN_OXYGEN_SATURATION", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_MIN_OXYGEN_SATURATION.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-eye-squeeze")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_EYE_SQUEEZE.mcpId}
              value={selectedMCPs.PIPP_EYE_SQUEEZE}
              handleChange={(val) => val && handleMCPChange("PIPP_EYE_SQUEEZE", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_EYE_SQUEEZE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
                {/* 2. Grup -  Maks kalp atışı - Min Oksijen saturation - Gözlerini Sıkma*/}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.pipp-scale.pipp-nasolabial-furrow")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.PIPP_NASOLABIAL_FURROW.mcpId}
              value={selectedMCPs.PIPP_NASOLABIAL_FURROW}
              handleChange={(val) =>
                val && handleMCPChange("PIPP_NASOLABIAL_FURROW", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.PIPP_NASOLABIAL_FURROW.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              {
                "3- Ağrı yok, 4-6 Hafif Ağrı, 7-9 Orta Şiddetli Ağrı, 10-12 Şiddetli Ağrı "
              }
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : 1</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default PippScale;
